import { Fragment } from 'react';
import { searchMatchRanges } from '@/lib/search-text';

/** Highlight literal matches without changing their original case or diacritics. */
export function SearchHighlight({ text, search }: { text: string; search: string }): JSX.Element {
  const ranges = searchMatchRanges(text, search);
  let end = 0;
  return (
    <>
      {ranges.map((range) => {
        const before = text.slice(end, range.start);
        end = range.end;
        return (
          <Fragment key={range.start}>
            {before}
            <mark className="ui-search-highlight">{text.slice(range.start, range.end)}</mark>
          </Fragment>
        );
      })}
      {text.slice(end)}
    </>
  );
}
